import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { APP_VERSION } from '@/const';

interface ILibraryStoreState {
    selectedSkillId?: string;
    setSelectedSkillId: (skillId?: string) => void;
    skillScripts: Record<string, string | undefined>;
    setSkillScript: (skillId: string, skillScript?: string) => void;
    flush: () => void;
}

const initialState = {
    selectedSkillId: undefined,
    skillScripts: {}
};

const useLibraryStore = create<ILibraryStoreState>()(
    persist(
        (set) => ({
            ...initialState,
            setSelectedSkillId: (selectedSkillId) => {
                set({ selectedSkillId });
            },
            setSkillScript: (skillId, skillScript) => {
                if (skillId) {
                    set((state) => ({
                        skillScripts: {
                            ...state.skillScripts,
                            [skillId]: skillScript
                        }
                    }));
                }
            },
            flush: () => {
                set(initialState);
            }
        }),
        {
            name: 'library-store',
            storage: createJSONStorage(() => globalThis.sessionStorage),
            partialize: (state) => state,
            version: APP_VERSION
        }
    )
);

export default useLibraryStore;
